(function ($) {
	function init(slide) {
		if (!slide) return;
		$(slide).slick({
			dots: false,
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			variableWidth: true,
			autoplay: true,
			arrows: false,
		});
	}
	$(".cm-logo-slider__logos").each(function (index, el) {
		init(el);
	});

	$(window).on("elementor/frontend/init", () => {
		setTimeout(() => {
			const $slides = elementorFrontend.elements.$body.find(
				".cm-logo-slider__logos",
			);

			$($slides).each(function (index, el) {
				init(el, index);
			});
		}, 2000);

		elementorFrontend.hooks.addAction(
			"frontend/element_ready/cm-logo-slider.default",
			($sope) => {
				var $slide = $sope.find(".cm-logo-slider__logos");
				init($slide);
			},
		);
	});
})(jQuery);
